import React, { useContext, useCallback, useState } from 'react'
import { Transition } from 'react-transition-group'
import { connect } from 'react-redux'
import * as Icon from 'react-feather'

import './PanelVersion.scss'
import { HeaderAnnotationContext } from '../../context/headerAnnotationContext'
import { convertToUserTimezone } from '../../../../shared/dateTimeHelper'
import { PreviewContext } from '../../context/previewContext'
import { VersionContext } from '../../context/versionContext'
import { TooltipContext } from '../../context/tooltipContext'
import { AbilityContext } from '../../../../context/abilityContext'
import { abilityAction, abilityComponent } from '../../../../shared/ability'

const duration = 300

const defaultStyle = {
  transition: `all ${duration}ms ease-in-out`,
  visibility: 'visible',
  opacity: 0,
  overflow: 'auto',
  // transform: `translateX(-100%)`,
}

const transitionStyles = {
  entered: {
    opacity: 1,
    // transform: `translateX(0)`,
    // visibility: 'visible'
  },
  exited: {
    opacity: 0,
    // transform: `translateX(-100%)`,
    // visibility: 'hidden'
  },
}

const VersionItem = ({
  version,
  onApproveVersion,
  onReviseVersion,
  orderProgress,
  user,
  onChangeVersion,
  className,
  index,
  onDeleteAttachmentVersion,
}) => {
  const abilityContext = useContext(AbilityContext)
  const [disabledApproveButton, setDisabledApproveButton] = useState(false)
  const [disabledReviseButton, setDisabledReviseButton] = useState(false)
  const [isDisabledDeleteVersion, setIsDisabledDeleteVersion] = useState(false)
  const { thumbnail } = version

  const handleApproveVersion = (e) => {
    setDisabledApproveButton(true)
    onApproveVersion(e, version.id)
    setTimeout(() => {
      setDisabledApproveButton(false)
    }, 10000)
  }

  const handleReviseVersion = (e) => {
    setDisabledReviseButton(true)
    onReviseVersion(e, version.id)
    setTimeout(() => {
      setDisabledReviseButton(false)
    }, 10000)
  }

  const handleDeleteAttachmentVersion = (e, version) => {
    setIsDisabledDeleteVersion(true)
    onDeleteAttachmentVersion(e, version)
    setTimeout(() => {
      setIsDisabledDeleteVersion(false)
    }, 5000)
  }

  return (
    <li onClick={(e) => onChangeVersion(e, index)} className={className}>
      <div className="d-flex flex-column">
        <div
          className="preview-version-file"
          style={{
            backgroundImage: `url(${thumbnail})`,
          }}
        >
          {abilityContext.can(
            abilityAction.READ,
            abilityComponent.ACTION_CM_APPROVE
          ) &&
            version.isInternalApproved && (
              <span className="badge badge-darkprimary">
                <Icon.CheckCircle className="feather" />
                <span>Approved</span>
              </span>
            )}

          {/* {abilityContext.can(
            abilityAction.UPDATE,
            abilityComponent.ACTION_CM_APPROVE
          ) &&
            version.isAllowedToReview &&
            orderProgress === 'in-progress' && ( */}
          <div className="toolbox-action">
            {abilityContext.can(
              abilityAction.UPDATE,
              abilityComponent.ACTION_CM_APPROVE
            ) &&
              version.isAllowedToReview &&
              orderProgress === 'in-progress' && (
                <>
                  {version.isInternalApproved ? (
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      id="btn-revise-version"
                      onClick={handleReviseVersion}
                      disabled={disabledReviseButton ? true : false}
                    >
                      <Icon.RefreshCcw className="feather" />
                      <span>Revise</span>
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-sm btn-darkprimary"
                      id="btn-approve-version"
                      onClick={handleApproveVersion}
                      disabled={disabledApproveButton ? true : false}
                    >
                      <Icon.CheckCircle className="feather" />
                      <span>Approve</span>
                    </button>
                  )}
                </>
              )}
            {abilityContext.can(
              abilityAction.UPDATE,
              abilityComponent.ASSIGNED_OPERATOR
            ) && (
              <>
                <button
                  type="button"
                  className="btn ml-2 btn-sm btn-danger"
                  id="btn-revise-version"
                  onClick={(e) => handleDeleteAttachmentVersion(e, version)}
                  disabled={
                    version.isInternalApproved ||
                    isDisabledDeleteVersion ||
                    version.disabledDelete
                      ? true
                      : false
                  }
                >
                  <Icon.Trash2 className="feather" />
                  <span>Delete</span>
                </button>
              </>
            )}
          </div>
          {/*  )} */}
        </div>
        <div className="text-center">
          {abilityContext.can(
            abilityAction.READ,
            abilityComponent.ACTION_CM_APPROVE
          ) &&
          version.version.toString() !== version.draftVersion.toString() ? (
            <span className="title">{`${version.fileName} - ${version.version} (approved from ${version.draftVersion})`}</span>
          ) : (
            <span className="title">{`${version.fileName} - ${version.version}`}</span>
          )}
        </div>
        <div className="text-center">
          <span className="time">
            {
              convertToUserTimezone(version.createdAt, user.timeZone)
                .simpleFormatDate
            }
          </span>
        </div>
      </div>
    </li>
  )
}

const PanelVersion = ({ user = null, onTogglePanel }) => {
  const { isShowVersionPanel, isShowPublicComment } = useContext(
    HeaderAnnotationContext
  )
  const {
    versions,
    onSelectedVersion,
    selectedInternalVersionIndex,
    selectedPublicVersionIndex,
    onSelectedInternalVersionIndex,
    onSelectedPublicVersionIndex,
    onChangeVersion,
    onApproveVersion,
    onReviseVersion,
    orderProgress,
    onDeleteAttachmentVersion,
  } = useContext(VersionContext)
  const { onIsLoadingFile } = useContext(PreviewContext)
  const { onShowTooltip } = useContext(TooltipContext)

  const handleChangeVersion = useCallback(
    (e, index) => {
      e.stopPropagation()
      e.nativeEvent.stopImmediatePropagation()

      if (isShowPublicComment) {
        if (selectedPublicVersionIndex !== index) {
          onIsLoadingFile(true)
          onShowTooltip(false)
          onSelectedPublicVersionIndex(index)
          onSelectedVersion(versions.public[index])
          onChangeVersion(versions.public[index].id, isShowPublicComment)
        }
      } else {
        if (selectedInternalVersionIndex !== index) {
          onIsLoadingFile(true)
          onShowTooltip(false)
          onSelectedInternalVersionIndex(index)
          onSelectedVersion(versions.internal[index])
          onChangeVersion(versions.internal[index].id, isShowPublicComment)
        }
      }
    },
    [
      isShowPublicComment,
      onChangeVersion,
      onIsLoadingFile,
      onSelectedInternalVersionIndex,
      onSelectedPublicVersionIndex,
      onSelectedVersion,
      onShowTooltip,
      selectedInternalVersionIndex,
      selectedPublicVersionIndex,
      versions,
    ]
  )

  return (
    <div
      className={`panel-versions-wrapper ${
        isShowVersionPanel ? 'collapsed' : ''
      }`}
    >
      <div className="collapse-panel" onClick={onTogglePanel}>
        <span>
          {isShowVersionPanel ? (
            <Icon.ChevronsLeft className="feather" />
          ) : (
            <Icon.ChevronsRight className="feather" />
          )}
        </span>
      </div>
      <Transition
        in={isShowVersionPanel}
        timeout={duration}
        unmountOnExit
        mountOnEnter
      >
        {(state) => (
          <div
            className="content"
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            {isShowPublicComment
              ? versions.public.length > 0 && (
                  <ul className="list-unstyled m-0">
                    {versions.public.map((version, key) => (
                      <VersionItem
                        key={key}
                        index={key}
                        version={version}
                        onApproveVersion={onApproveVersion}
                        onReviseVersion={onReviseVersion}
                        orderProgress={orderProgress}
                        oChangeVersion={handleChangeVersion}
                        className={
                          isShowPublicComment
                            ? selectedPublicVersionIndex === key
                              ? 'active'
                              : ''
                            : selectedInternalVersionIndex === key
                            ? 'active'
                            : ''
                        }
                        user={user}
                        onChangeVersion={handleChangeVersion}
                        onDeleteAttachmentVersion={onDeleteAttachmentVersion}
                      />
                    ))}
                  </ul>
                )
              : versions.internal.length > 0 && (
                  <ul className="list-unstyled m-0">
                    {versions.internal.map((version, key) => (
                      <VersionItem
                        key={key}
                        index={key}
                        version={version}
                        onApproveVersion={onApproveVersion}
                        onReviseVersion={onReviseVersion}
                        orderProgress={orderProgress}
                        oChangeVersion={handleChangeVersion}
                        className={
                          isShowPublicComment
                            ? selectedPublicVersionIndex === key
                              ? 'active'
                              : ''
                            : selectedInternalVersionIndex === key
                            ? 'active'
                            : ''
                        }
                        user={user}
                        onChangeVersion={handleChangeVersion}
                        onDeleteAttachmentVersion={onDeleteAttachmentVersion}
                      />
                    ))}
                  </ul>
                )}
          </div>
        )}
      </Transition>
    </div>
  )
}

const mapStateToProps = ({ user }) => {
  return { user }
}

export default connect(mapStateToProps, null)(React.memo(PanelVersion))
